import { ButtonGroup } from "@blueprintjs/core"
import { useEffect, useState } from "react"
import { DIALOG_SIZE, LAND_TYPE } from "src/libs/interfaces/layouts"
import { coords, land_group_id } from "src/libs/layouts"
import { MAP_DIALOG_MODE, Map as YandexMap } from "src/libs/yandexMap"
import { IMapProps } from "src/libs/yandexMap/Map"
import { GET_FEED_ACTION } from "src/modules/pe-basic-module/data/actionTypes"
import { ILand, IPEFestSchool } from "src/modules/pe-fest-module/data/interfaces"
import basicActions from "../../../pe-basic-module/data/actions"
import { IEvent, MAP_FILTER } from "../../data/interfaces"
import { IToposPostsStore, IToposStore, useToposPostsStore, useToposStore } from "../../data/store"
import MapDialog from "./MapDialog"
import MapTypeButton from "./MapTypeButton"


interface _IMapProps {
    onOpenLogin?: () => void,
    setIsReloading?: (isLoading: boolean) => void
}
const Map = (props: _IMapProps) : JSX.Element => { 
    const [events, setEvents] = useState<IEvent[]>( useToposPostsStore.getState().events ) 
    const [isLoading, setIsLoading] = useState<boolean>(false) 
    const [isOpen, setIsOpen] = useState<boolean>(false) 
    const [markers, setMarkers] = useState<any[]>([])
    const [dialogData, setDialogData] = useState<any>(<></>) 
    const [mode, setMode] = useState<MAP_DIALOG_MODE>( MAP_DIALOG_MODE.NONE ) 
    const mapCoords: number[] = useToposStore((state: IToposStore) => state.mapCoords)
    const setMapCoords: ((mapCoords: number[]) => void) = useToposStore((state: IToposStore) => state.setMapCoords)
    const mapMode: MAP_FILTER = useToposStore((state: IToposStore) => state.mapMode)
    const setMapMode: ((mapMode: MAP_FILTER) => void) = useToposStore((state: IToposStore) => state.setMapMode)
    
    const updateEvents = ( ) => { 
        basicActions(GET_FEED_ACTION, { 
            data_type: "Land",
            paging: ` meta_relation: "AND"  metas: [  {key: "land_type", value: "${LAND_TYPE.EVENT}"}, ${ land_group_id() ? `{ key: "land_group_id", value: "${ land_group_id() }" }` : `` },  { key: "hidden", value_bool: false }, { key: "archived", value_bool: false } ] `
        })
        .then(resp => {
            setIsLoading(false)
            setMarkers(
                resp.feed.map((event: ILand) => { 
                    return {
                        dataType:"Event",
                        placeTypes: [ {
                            id: 12233,
                            color: event.color || "#cd4246",
                            icon: event.icon || "/assets/img/topos/graduation-cap.png",
                        }], 
                        coordinates: !!event.geo?.length ?  event.geo[0] : coords(), 
                        draggable: false, 
                        hintContent: event.title, 
                        icon: "/assets/img/topos/graduation-cap.png",
                        onClick: onMarkerClick ,
                        data: event,
                        color: event.color || "#cd4246"
                    }
                })
            )
        }) 
    }
    
    const updateTreasuries = ( ) => { 
        basicActions(GET_FEED_ACTION, { 
            data_type: "Land",
            paging: ` meta_relation: "AND"  metas: [  {key: "land_type", value: "${LAND_TYPE.TREASURY}"}, ${ land_group_id() ? `{ key: "land_group_id", value: "${ land_group_id() }" }` : `` },  { key: "hidden", value_bool: false }, { key: "archived", value_bool: false } ] `
        })
        .then(resp => {
            setIsLoading(false)
            setMarkers(
                resp.feed.map((event: ILand) => { 
                    return {
                        dataType:"Event",
                        placeTypes: [ {
                            id: 12233,
                            color: event.color || "#cd4246",
                            icon: event.icon || "/assets/img/topos/folder-tree.svg",
                        }], 
                        coordinates: !!event.geo?.length ?  event.geo[0] : coords(), 
                        draggable: false, 
                        hintContent: event.title, 
                        icon: "/assets/img/topos/folder-tree.svg",
                        onClick: onMarkerClick ,
                        data: event,
                        color: event.color || "#cd4246"
                    }
                })
            )
        }) 
    }
    const updatePlaces = () => { 
        basicActions(GET_FEED_ACTION, { 
            data_type: "PEFestSchool"
        })
        .then(resp => {
            setIsLoading(false)
            setMarkers(
                resp.feed.map((place: IPEFestSchool) => {
                    //const placeType: IPlaceType = placeTypes().filter( p => p.id === place.type[0] )[0] || placeTypes()[0]
                    return {
                        dataType:"Place",
                        placeTypes: [ {
                            id: 12233,
                            color: "#673c29",
                            icon: "/assets/img/topos/graduation-cap.png",
                        }], 
                        coordinates: place.geo, 
                        draggable: false, 
                        hintContent: place.title, 
                        icon: "/assets/img/topos/graduation-cap.png",
                        onClick: onMarkerClick ,
                        data: { ...place, defaultThumbnail: place.thumbnail, content: place.post_content },
                        color: "#673c29"
                    }
                })
            )
        })
    }
    const updateTeams = () => {
        basicActions(GET_FEED_ACTION, { 
            data_type: "Land",
            paging: ` meta_relation: "AND"  metas: [  {key: "land_type", value: "${LAND_TYPE.TEAM}"}, ${ land_group_id() ? `{ key: "land_group_id", value: "${ land_group_id() }" }` : `` },  { key: "hidden", value_bool: false }, { key: "archived", value_bool: false } ] `
        })
        .then(response => {
            setIsLoading(false)
            setMarkers(
                response.feed.map((team: ILand) => { 
                    return {
                        dataType:"Team",
                        placeTypes: [ {
                            id: 12233,
                            color: team.color || "#b0b747",
                            icon: team.icon || "/assets/img/topos/people-group.png",
                        }], 
                        coordinates: !!team.geo?.length ?  team.geo[0] : coords(), 
                        draggable: false, 
                        hintContent: team.title, 
                        icon: "/assets/img/topos/people-group.png",
                        onClick: onMarkerClick ,
                        data: team,
                        color: team.color || "#b0b747"
                    }
                })
            )
        })
    }

    const updateMarkers = (_events: IEvent[] | null = null) => {
        setIsLoading(true)
        switch(mapMode) {
            case MAP_FILTER.TREASURY:
                updateTreasuries()
                break
            case MAP_FILTER.PLACES:
                updatePlaces()
                break
            case MAP_FILTER.TEAM:
                updateTeams()
                break            
            case MAP_FILTER.EVENTS: 
            default:
                updateEvents()
                break
        }
    }
    
    useEffect(() => useToposPostsStore.subscribe(
        (state:IToposPostsStore) => {
            setEvents(state.events)
            updateMarkers( state.events ) 
        }
    ), [])

    useEffect (() => { 
        updateMarkers() 
    }, [mapMode ])

    const onFilter = (filter: MAP_FILTER) => {
        setMapMode(filter)
    }
    
    const onClick = ( coords : number[] ) => {
        setMapCoords( coords )
        // console.log( coords )
    }
    const onClusterClick = ( evt:any, coords: number[], data: any[] ) => { 
        setDialogData( data )
        setMode( MAP_DIALOG_MODE.CLUSTER_DATA )
        setIsOpen( true )
    }
    const onWeel = (coords : number[]) => {
        setMapCoords(coords) 
    }
    const onMarkerClick = ( evt:any, coords: number[], data: any ) => {
        //console.log( data )
        setDialogData( data )
        setMode( MAP_DIALOG_MODE.MARKER_DATA )
        setIsOpen( true )
    }
    const onBeforeDrawMap = () : IMapProps => {
        // console.log( markers )
        updateMarkers()
        if(props.setIsReloading) {
            props.setIsReloading( false )
        }
        return  { markers }
    } 
    return <div className="position-relative w-100 h-100">  
        <YandexMap
            width="100%"
            height="100%"
            coordinates={ mapCoords }
            markers={ markers }
            onClick={onClick}
            onClusterClick={onClusterClick}
            onWeel={onWeel}
            onBeforeDrawMap={onBeforeDrawMap} 
        >
            
        </YandexMap>  
        <MapDialog 
            isOpen={isOpen}
            mode={mode}
            type={mapMode}
            data={dialogData}
            size={DIALOG_SIZE.LARGE_ELEGNSE}
            onClose={() => setIsOpen(false)}
            onOpenLogin={props.onOpenLogin}
        />
        <ButtonGroup className="position-absolute m-2 top left">
            {
                Object.keys(MAP_FILTER)
                    //.filter(mapType => mapType !== MAP_FILTER.TREASURY )
                    .map(( mapType , i ) => {
                        return <MapTypeButton
                            key={mapMode + i} 
                            mapType={mapType}
                            markers={markers}
                            isLoading={isLoading}
                            onFilter={onFilter}
                            onMarkerClick={onMarkerClick}
                        />
                    })
            }
        </ButtonGroup>
    </div>
}
export default Map